import { type ContextMenuList } from '../types/context-menu-list.type';

// menu item imports
import { convertToCornerTrimMenuItem } from '../menu-item/convert-to-corner-trim-menu-item';
import { convertToFlatTrimMenuItem } from '../menu-item/convert-to-flat-trim-menu-item';

export const cornerMenuList: Array<ContextMenuList> = [
	convertToFlatTrimMenuItem(),
	convertToCornerTrimMenuItem()
];
